/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export enum SimPlanType {
        PREPAID,
        POSTPAID,
        UNKOWN
    }

    export interface ISimPlan {
        href: string;
        name: string;
        operatorName: string;
        operatorCountry: string;
        type: string;
        dataAmount: number;
    }

    export class SimPlan implements ISimPlan {
        public href: string;
        public name: string;
        public operatorName: string;
        public operatorCountry: string;
        public type: string;
        public dataAmount: number;

        public static Empty(): SimPlan {
            return new SimPlan();
        }

        public static Copy(plan: SimPlan): SimPlan {
            let newPlan: SimPlan = new SimPlan();
            newPlan.href = plan.href;
            newPlan.name = plan.name;
            newPlan.operatorName = plan.operatorName;
            newPlan.operatorCountry = plan.operatorCountry;
            newPlan.type = plan.type;
            newPlan.dataAmount = plan.dataAmount;
            return newPlan;
        }

        /**
         * NetworkNode's empty constructor for automatic conversion from
         * REST data.
         */
        constructor() {
            this.href = '';
            this.name = '';
            this.operatorName = '';
            this.operatorCountry = '';
            this.type = '';
            this.dataAmount = 0;
        }
    }
}
